import { Breadcrumb } from "./BreadcrumbsContext";

type BreadcumbItem = {
  path: string;
  breadcrumbs: Breadcrumb[];
};

const ADMIN_BREADCRUMBS_MAP: BreadcumbItem[] = [
  {
    path: "/admin/course/:courseId",
    breadcrumbs: [{ label: "Courses", to: "/admin/courses" }],
  },
  {
    path: "/admin/program/:programId",
    breadcrumbs: [{ label: "Programs", to: "/admin/programs" }],
  },
  {
    path: "/admin/users/create",
    breadcrumbs: [{ label: "Users", to: "/admin/users" }],
  },
  {
    path: "/admin/users/edit/:userId",
    breadcrumbs: [{ label: "Users", to: "/admin/users" }],
  },
  {
    path: "/admin/posts/create",
    breadcrumbs: [{ label: "Posts", to: "/admin/posts" }],
  },
  {
    path: "/admin/posts/edit/:postId",
    breadcrumbs: [{ label: "Posts", to: "/admin/posts" }],
  },
  {
    path: "/admin/notifications/create-notification",
    breadcrumbs: [{ label: "Notifications", to: "/admin/notifications" }],
  },
  {
    path: "/admin/notifications/edit-notification/:notificationId",
    breadcrumbs: [{ label: "Notifications", to: "/admin/notifications" }],
  },
  {
    path: "/admin/course-report/:courseId",
    breadcrumbs: [{ label: "Courses", to: "/admin/reports/courses" }, { label: "..." }],
  },
  {
    path: "/admin/user-report/:userId",
    breadcrumbs: [{ label: "Users", to: "/admin/reports/users" }, { label: "..." }],
  },
  {
    path: "/admin/user-report/:userId/course/:courseId",
    breadcrumbs: [{ label: "Users", to: "/admin/reports/users" }, { label: "..." }, { label: "..." }],
  },
  {
    path: "/admin/user-report/:userId/program/:programId",
    breadcrumbs: [{ label: "Users", to: "/admin/reports/users" }, { label: "..." }, { label: "..." }],
  },
  {
    path: "/admin/program-report/:programId",
    breadcrumbs: [{ label: "Programs", to: "/admin/reports/programs" }, { label: "..." }],
  },
  {
    path: "/admin/program-report/:programId/course/:courseId",
    breadcrumbs: [{ label: "Programs", to: "/admin/reports/programs" }, { label: "..." }, { label: "..." }],
  },
];

const CONSUMER_BREADCRUMBS_MAP: BreadcumbItem[] = [
  {
    path: "/explore/courses/:courseId",
    breadcrumbs: [{ label: "My Courses", to: "/explore/my-learning" }, { label: "..." }],
  },
  {
    path: "/explore/courses/:courseId/chapter/:chapterId",
    breadcrumbs: [{ label: "My Courses", to: "/explore/my-learning" }, { label: "..." }, { label: "..." }],
  },
  {
    path: "/explore/program/:programId",
    breadcrumbs: [{ label: "My Courses", to: "/explore/my-learning" }, { label: "..." }],
  },
  {
    path: "/explore/program/:programId/course/:courseId",
    breadcrumbs: [{ label: "My Courses", to: "/explore/my-learning" }, { label: "..." }, { label: "..." }],
  },
  {
    path: "/explore/program/:programId/course/:courseId/chapter/:chapterId",
    breadcrumbs: [{ label: "My Courses", to: "/explore/my-learning" }, { label: "..." }, { label: "..." }, { label: "..." }],
  },
];

export const BREADCRUMBS_MAP: BreadcumbItem[] = [...ADMIN_BREADCRUMBS_MAP, ...CONSUMER_BREADCRUMBS_MAP];
